<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalGrossValue.title"
                        [body]="{
                            value: kpi.totalGrossValue,
                            precision: texts.totalGrossValue.precision,
                            suffix: texts.totalGrossValue.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalGrossValueEvolution,
                            suffix: texts.totalGrossValue.badgeSuffix,
                            precision: texts.totalGrossValue.badgePrecision,
                            style: kpi.totalGrossValueEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.totalGrossValue.descriptionTitle"
                        [descriptionContent]="texts.totalGrossValue.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalGrossValue')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.grossValuePerUserRatio.title"
                        [body]="{
                            value: kpi.grossValuePerUserRatio,
                            precision: texts.grossValuePerUserRatio.precision,
                            suffix: texts.grossValuePerUserRatio.suffix,
                        }"
                        [badge]="{
                            value: kpi.grossValuePerUserRatioEvolution,
                            suffix: texts.grossValuePerUserRatio.badgeSuffix,
                            precision: texts.grossValuePerUserRatio.badgePrecision,
                            style: kpi.grossValuePerUserRatioEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'grossValuePerUserRatio')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalRenewalProvision.title"
                        [body]="{
                            value: kpi.totalRenewalProvision,
                            precision: texts.totalRenewalProvision.precision,
                            suffix: texts.totalRenewalProvision.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalRenewalProvisionEvolution,
                            suffix: texts.totalRenewalProvision.badgeSuffix,
                            precision: texts.totalRenewalProvision.badgePrecision,
                            style: kpi.totalRenewalProvisionEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.totalRenewalProvision.descriptionTitle"
                        [descriptionContent]="texts.totalRenewalProvision.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalRenewalProvision')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.overallDepreciationRate.title"
                        [body]="{
                            value: kpi.overallDepreciationRate,
                            precision: texts.overallDepreciationRate.precision,
                            suffix: texts.overallDepreciationRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.overallDepreciationRateEvolution,
                            suffix: texts.overallDepreciationRate.badgeSuffix,
                            precision: texts.overallDepreciationRate.badgePrecision,
                            style: kpi.overallDepreciationRateEvolution! < 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.overallDepreciationRate.descriptionTitle"
                        [descriptionContent]="texts.overallDepreciationRate.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'overallDepreciationRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="evolutionFixedAssetsChart"
                [title]="texts.evolutionFixedAssetsChart.title"
                [error]="chartError"
                [isLoading]="!chartData()[0].organizationId"
                [series]="chartSeries"
                [dataLabels]="dataLabels"
                [stacked]="true"
                [yaxis]="yaxis"
                [xaxisCategories]="xaxisCategories"
                [precision]="texts.evolutionFixedAssetsChart.precision"
                [xaxisTitle]="texts.evolutionFixedAssetsChart.xaxisTitle"
                [legend]="evolutionFixedAssetsegend"
                [customTooltip]="evolutionFixedAssetsCustomTooltip"
                class="h-100">
            </chart-card>

            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="grossValueEvol"
                        [title]="texts.grossValueEvolChart.title"
                        [error]="chartErrorEvolVb"
                        [isLoading]="!chartDataEvolVb()[0].organizationId"
                        [series]="chartSeriesEvolVb"
                        [dataLabels]="dataLabelsEvolVb"
                        [stacked]="true"
                        [xaxisCategories]="xaxisCategoriesEvolVb"
                        [yaxis]="yaxisEvolVb"
                        [precision]="texts.grossValueEvolChart.precision"
                        [xaxisTitle]="texts.grossValueEvolChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="grossValueRatioComparison"
                        [title]="texts.grossValueRatioComparisonChart.title"
                        [descriptionTitle]="texts.grossValueRatioComparisonChart.descriptionTitle"
                        [descriptionContent]="
                            texts.grossValueRatioComparisonChart.descriptionContent
                        "
                        [error]="grossValueRatioComparisonChartError"
                        [isLoading]="!grossValueRatioComparisonChartDataSignal()[0].organizationId"
                        [type]="'rangeBar'"
                        [yaxis]="grossValueRatioChartYaxis"
                        [dataLabels]="comparisonDataLabels"
                        [series]="grossValueRatioComparisonChartSeries"
                        [plotOptions]="grossValueRatioComparisonPlotOptions"
                        [customTooltip]="grossValueRatioComparisonCustomTooltip"
                        cardClass="h-100"></chart-card>
                </div>

                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="grossValueChart"
                        [title]="texts.grossValueBreakdownChart.title"
                        [error]="grossValueChartError"
                        [isLoading]="!grossValueChartData()[0].organizationId"
                        [series]="grossValueChartSeries"
                        [dataLabels]="grossValueDataLabels"
                        [labels]="grossValueLabels"
                        [colors]="grossValueColors"
                        type="pie"
                        [unitTooltip]="texts.grossValueBreakdownChart.unitTooltip"
                        [fill]="{ opacity: 0.9 }"
                        cardClass="h-100"></chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="rateDeprWorkEvol"
                        [title]="texts.rateDeprWorkEvolChart.title"
                        [error]="chartErrorEvolRep"
                        [isLoading]="!chartDataEvolVb()[0].organizationId"
                        [series]="chartSeriesEvolRep"
                        [dataLabels]="dataLabelsEvolRep"
                        [stacked]="true"
                        [xaxisCategories]="xaxisCategoriesEvolRep"
                        [yaxis]="yaxisDeprWorkEvol"
                        [precision]="texts.rateDeprWorkEvolChart.precision"
                        [xaxisTitle]="texts.rateDeprWorkEvolChart.xaxisTitle"
                        [unitTooltip]="texts.rateDeprWorkEvolChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
            </div>

            <chart-card
                id="rateDeprWorksFamily"
                [title]="texts.rateDeprWorksFamilyChart.title"
                [error]="chartErrorRateRep"
                [isLoading]="!chartDataRateRep()[0].organizationId"
                [series]="chartSeriesRateRep"
                [dataLabels]="dataLabelsRateRep"
                [type]="'bar'"
                [xaxisCategories]="xaxisCategoriesRateRep"
                [yaxis]="yaxisRateWorksFamily"
                [sharedTooltip]="true"
                [plotOptions]="rateRepPlotOptions"
                [precision]="texts.rateDeprWorksFamilyChart.precision"
                [xaxisTitle]="texts.rateDeprWorksFamilyChart.xaxisTitle"
                class="h-100">
            </chart-card>

            <chart-card
                id="depreciationRateComparison"
                [title]="texts.depreciationRateComparisonChart.title"
                [descriptionTitle]="texts.depreciationRateComparisonChart.descriptionTitle"
                [descriptionContent]="texts.depreciationRateComparisonChart.descriptionContent"
                [error]="deprecRateComparisonChartError"
                [isLoading]="!deprecRateComparisonChartDataSignal()[0].organizationId"
                [type]="'rangeBar'"
                [dataLabels]="comparisonDataLabels"
                [series]="deprecRateComparisonChartSeries"
                [plotOptions]="deprecRateComparisonPlotOptions"
                [customTooltip]="depreciationRateComparisonCustomTooltip"
                [yaxis]="depreciationRateComparisonChartYaxis"
                cardClass="h-100"></chart-card>

            <div class="row g-3">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="replacementValueChart"
                        [title]="texts.replacementValueChart.title"
                        [error]="replacementValueChartError"
                        [isLoading]="!replacementValuechartData()[0].organizationId"
                        [series]="replacementValueChartSeries"
                        [dataLabels]="replacementValueDataLabels"
                        [stacked]="true"
                        [xaxisCategories]="replacementValueXaxisCategories"
                        [yaxis]="replacementValueYaxis"
                        [customTooltip]="replacementValueCustomTooltip"
                        [xaxisTitle]="texts.replacementValueChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="totalProvisionChart"
                        [title]="texts.totalProvisionChart.title"
                        [error]="totalProvisionChartError"
                        [isLoading]="!totalProvisionChartData()[0].organizationId"
                        [series]="totalProvisionChartSeries"
                        [dataLabels]="totalProvisionDataLabels"
                        [stacked]="true"
                        [xaxisCategories]="totalProvisionXaxisCategories"
                        [yaxis]="totalProvisionYaxis"
                        [grid]="totalProvisionGrid"
                        [customTooltip]="totalProvisionCustomTooltip"
                        [xaxisTitle]="texts.totalProvisionChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
            </div>

            <chart-card
                id="provisionsDistributionChart"
                [title]="texts.provisionsDistributionChart.title"
                [error]="provisionsDistributionChartError"
                [isLoading]="!provisionsDistributionChartData()[0].organizationId"
                [series]="provisionsDistributionChartSeries"
                [dataLabels]="provisionsDistributionDataLabels"
                [labels]="provisionsDistributionLabels"
                [colors]="provisionsDistributionColors"
                type="pie"
                [unitTooltip]="texts.provisionsDistributionChart.unitTooltip"
                [fill]="{ opacity: 0.9 }"
                cardClass="h-100"></chart-card>
        </div>
    </div>
</div>
